// TODO: Локализация
export const InvoiceCreatorItemGridPluginSettings: IPluginSettings = {
    name: "Позиции",
    mnemocode: "invoice_item_create_plugin",
    permission: "Invoice",
    columns: [
        {
            order: 0,
            propertyName: "lineStatus",
            propertyType: "string",
            displayName: "Статус строки",
            visibility: true,
            width: 60,
        },
        {
            order: 1,
            propertyName: "idGlobal",
            propertyType: "string",
            displayName: "idGlobal",
            visibility: false,
            width: 100,
        },
        {
            order: 2,
            propertyName: "goodsName",
            propertyType: "string",
            displayName: "Товар",
            visibility: true,
            width: 150,
        },
        {
            order: 3,
            propertyName: "scalingRatioName",
            propertyType: "string",
            displayName: "Упаковка",
            visibility: true,
            width: 150,
        },
        {
            order: 4,
            propertyName: "quantity",
            propertyType: "number",
            displayName: "Количество",
            visibility: true,
            width: 150,
            changeable: true,
        },
        {
            order: 5,
            propertyName: "actualQuantity",
            propertyType: "number",
            displayName: "Количество факт.",
            visibility: true,
            width: 150,
        },
        {
            order: 6,
            propertyName: "damageQuantity",
            propertyType: "number",
            displayName: "Бой",
            visibility: true,
            width: 150,
        },
        {
            order: 7,
            propertyName: "defectQuantity",
            propertyType: "number",
            displayName: "Брак",
            visibility: true,
            width: 150,
        },
        {
            order: 8,
            propertyName: "shortageQuantity",
            propertyType: "number",
            displayName: "Недостача",
            visibility: true,
            width: 150,
        },
        {
            order: 9,
            propertyName: "retailPriceIncVat",
            propertyType: "decimal",
            displayName: "Цена с НДС, розн.",
            visibility: true,
            width: 150,
            changeable: true,
        },
        {
            order: 10,
            propertyName: "gtin",
            propertyType: "string",
            displayName: "Gtin",
            visibility: true,
            width: 150,
            changeable: true,
        },
        {
            order: 11,
            propertyName: "retailAmount",
            propertyType: "number",
            displayName: "Сумма розничная",
            visibility: true,
            width: 150,
        },
        {
            order: 12,
            propertyName: "retailAmountIncVat",
            propertyType: "number",
            displayName: "Сумма розничная с НДС",
            visibility: true,
            width: 150,
        },
        {
            order: 13,
            propertyName: "retailVat",
            propertyType: "number",
            displayName: "НДС розничная",
            visibility: true,
            width: 150,
        },
        {
            order: 14,
            propertyName: "supplierAmount",
            propertyType: "number",
            displayName: "Сумма поставщика",
            visibility: true,
            width: 150,
        },
        {
            order: 15,
            propertyName: "supplierAmountIncVat",
            propertyType: "number",
            displayName: "Сумма поставщика с НДС",
            visibility: true,
            width: 150,
        },
        {
            order: 16,
            propertyName: "supplierPrice",
            propertyType: "number",
            displayName: "Цена поставщика",
            visibility: true,
            width: 150,
        },
        {
            order: 17,
            propertyName: "supplierPriceIncVat",
            propertyType: "number",
            displayName: "Цена с НДС, пост.",
            visibility: true,
            width: 150,
        },
        {
            order: 18,
            propertyName: "supplierVat",
            propertyType: "number",
            displayName: "НДС поставщика",
            visibility: true,
            width: 150,
        },
        {
            order: 19,
            propertyName: "producerPrice",
            propertyType: "number",
            displayName: "Цена производителя",
            visibility: true,
            width: 150,
        },
        {
            order: 20,
            propertyName: "productMargin",
            propertyType: "number",
            displayName: "Наценка розн.",
            visibility: true,
            width: 150,
        },
        {
            order: 21,
            propertyName: "isKiz",
            propertyType: "boolean",
            displayName: "Ввод киз",
            visibility: true,
            width: 150,
        },
        {
            order: 22,
            propertyName: "isGnvls",
            propertyType: "boolean",
            displayName: "ЖНВЛП",
            visibility: true,
            width: 150,
        },
        {
            order: 23,
            propertyName: "countKizScan",
            propertyType: "number",
            displayName: "Кол-во отсканированных кизов",
            visibility: true,
            width: 150,
        },
        {
            order: 24,
            propertyName: "numerator",
            propertyType: "number",
            displayName: "Числитель",
            visibility: false,
            width: 150,
        },
        {
            order: 25,
            propertyName: "denominator",
            propertyType: "number",
            displayName: "Знаменатель",
            visibility: false,
            width: 150,
        },
        {
            order: 26,
            propertyName: "retailPrice",
            propertyType: "number",
            displayName: "Цена без НДС розн.",
            visibility: true,
            width: 150,
        },
        {
            order: 27,
            propertyName: "idInvoiceItemGroupGlobal",
            propertyType: "string",
            displayName: "Группа пересорта",
            visibility: false,
            width: 200,
        },
        {
            order: 28,
            propertyName: "seriesNumber",
            propertyType: "string",
            displayName: "Серия",
            visibility: true,
            width: 200,
        },
        {
            order: 29,
            propertyName: "bestBefore",
            propertyType: "date",
            displayName: "Срок годности",
            visibility: true,
            width: 200,
        },
        {
            order: 30,
            propertyName: "isOsu",
            propertyType: "boolean",
            displayName: "Признак воды",
            visibility: true,
            width: 200,
        },
        {
            order: 31,
            propertyName: "goodsCode",
            propertyType: "string",
            displayName: "Код товара",
            visibility: true,
            width: 200,
        },
        {
            order: 32,
            propertyName: "producer",
            propertyType: "string",
            displayName: "Производитель",
            visibility: true,
            width: 200,
        },
        {
            order: 32,
            propertyName: "storePlaceName",
            propertyType: "string",
            displayName: "Место хранения",
            visibility: true,
            width: 200,
        },
    ],
};
